var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 72,
    viewBox: "0 0 74 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9878_7010)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.9993,
    cy: 36,
    rx: 36.4436,
    ry: 36,
    fill: "#CF9D61",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.1973,
    cy: 36.1995,
    rx: 26.5777,
    ry: 26.2541,
    fill: "#CF9D61",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1564 30.6016C38.1112 30.6016 39.0268 30.9808 39.702 31.656C40.3771 32.3311 40.7564 33.2468 40.7564 34.2016V46.8016C40.7564 47.7563 40.3771 48.672 39.702 49.3471C39.0268 50.0223 38.1112 50.4016 37.1564 50.4016C36.2016 50.4016 35.2859 50.0223 34.6108 49.3471C33.9357 48.672 33.5564 47.7563 33.5564 46.8016V34.2016C33.5564 33.2468 33.9357 32.3311 34.6108 31.656C35.2859 30.9808 36.2016 30.6016 37.1564 30.6016Z",
    fill: "#CF9D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7564 25.2016C40.7564 26.1563 40.3771 27.072 39.702 27.7471C39.0268 28.4223 38.1112 28.8016 37.1564 28.8016C36.2016 28.8016 35.2859 28.4223 34.6108 27.7471C33.9357 27.072 33.5564 26.1563 33.5564 25.2016C33.5564 24.2468 33.9357 23.3311 34.6108 22.656C35.2859 21.9808 36.2016 21.6016 37.1564 21.6016C38.1112 21.6016 39.0268 21.9808 39.702 22.656C40.3771 23.3311 40.7564 24.2468 40.7564 25.2016Z",
    fill: "#CF9D61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9878_7010"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72.8873,
    height: 72,
    fill: "white",
    transform: "translate(0.556396)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertWarningIcon);
export default __webpack_public_path__ + "static/media/alert-warning-icon.4c7dbcb6affc672bdfffd281510bd050.svg";
export { ForwardRef as ReactComponent };